'use strict';

exports.__esModule = true;
exports.Refers = undefined;

var _Refers2 = require('./refer/Refers');

var _Refers3 = _interopRequireDefault(_Refers2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.Refers = _Refers3['default'];


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/index.js
// module id = 315
// module chunks = 0